import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'
function EditIndentEqp() {

  const {id}=useParams();
  const [errorMsg, seterrorMsg] = useState('');
  const [succesMsg, setsuccessMsg] = useState('');

  const [registerFormData, setRegisterFormData] = useState({
        "issue_qty":'',
        "addedby":'',
        "ip_add":'',
    });
    useEffect(() => {
        try{
            axios.get(baseUrl+'update-indent-eqp/'+id+'/')
            .then(function (response) {
                setRegisterFormData({
                    product:response.data.product.product,
                    issued_qty:response.data.issued_qty,
                });
            });
        }catch(error){
            console.log(error);
        }

    },[]);

   const handleChange = (event) => {
      setRegisterFormData({
            ...registerFormData,
            [event.target.name]:event.target.value
        });
  };

  const submitHandler = (e) => {
     e.preventDefault();

        const formData = new FormData();
        formData.append('issued_qty',registerFormData.issued_qty);
        formData.append('addedby', userName);
        formData.append('ip_add', ipAddress);
          formData.append('location', userLocation);

        axios.put(baseUrl+'update-indent-eqp/'+id+'/', formData)
          .then((response) => {
              if(response.status==200 || response.status==201){
                Swal.fire({
                  title: 'Qty has been Updated.',
                  icon: 'success',
                  timer: 5000,
                  showConfirmButton: false
                });
                setTimeout(() => {
                  window.location.href = '/indent-eqp-list';
                }, 3000);
              }
            })
              .catch(error => {
              console.log(error);
                  Swal.fire(
                    'Error!',
                    'Failed to add. Please try again later.',
                    'error'
                  );
              });
  };

  return (
        <section className="container mt-4">
            <div className="row">
              <div className="col-md-8 col-12">
                <div className='card'>
                    <h4 className='card-header text-center'>Edit Equipment Issued Qty</h4>
                    <div className='card-body'>
                        <p className="text-muted"><strong>Note:</strong>All are Mandatory Fields</p>
                        {succesMsg && <p className="text-success">{succesMsg}</p>}
                        {errorMsg && <p className="text-danger">{errorMsg}</p>}
                        <form>

                        <div className="row">
                        <div className="col-md-6 mb-3">
                            <label htmlFor="TQty" className="form-label">Product : </label><br />
                            {registerFormData.product}
                        </div>
                        <div className="col-md-6 mb-3">
                            <label htmlFor="TQty" className="form-label">TQty</label><br />
                            <input type="number" maxLength={10} placeholder="TQty" className="form-control"
                                name="issued_qty" value={registerFormData.issued_qty} onChange={handleChange} />
                        </div>
                        </div>

                        <div className="row">
                        <div className="col-md-12 text-center">
                        <button type="button" onClick={submitHandler}
                        className="btn btn-success">Update</button>
                        </div>
                        </div>
                        </form>
                    </div>
                </div>
              </div>
            </div>
        </section>
  );
}

export default EditIndentEqp;
